import { useMemo, useState } from "react";
import { bool, number, oneOfType, string } from "prop-types";
import { useTranslation } from "react-i18next";
import { MAX_WORK_TYPE_LENGTH } from "@repo/utils";
import { generateWorkTypeId } from "@repo/structure";
import { useXlsImporterSettings } from "@tools";
import { Autocomplete } from "@components";
import useStyle from "../../Steps.style";
import classnames from "classnames";
import { simplifyTextString } from "@utils";
import { useTheme } from "@material-ui/core";

export const WorkTypeSelector = ({
  index,
  id,
  name,
  isCustom
}) => {
  const { t } = useTranslation();
  const settings = useXlsImporterSettings();
  const theme = useTheme();
  const classes = useStyle();

  const [ localValue, setValue ] = useState(name || "");

  const { workTypes, customWorkTypes, importWorkTypes } = settings;

  const filtered = useMemo(() => [
    ...workTypes,
    ...customWorkTypes,
  ], [ workTypes, customWorkTypes ]);

  const handleChange = (_, newWorkType) => {
    if(isCustom)
      settings.removeCustomWorkType(id);
    settings.updateImportWorkType(index, newWorkType);
  };

  const handleInputChange = (v) => {
    setValue(v.slice(0, MAX_WORK_TYPE_LENGTH));
  };

  const handleWorkTypeCreate = (name) => {
    const selected = importWorkTypes.find(wT => simplifyTextString(wT.name) === simplifyTextString(name));
    if(selected)
      return;
    
    const existing = filtered.find(wT => simplifyTextString(wT.name) === simplifyTextString(name));
    if(existing)
      return existing;
    
    const newWT = {
      id: generateWorkTypeId(),
      name,
      xls: true,
      backgroundColor: theme.palette.primary.main,
    }
    settings.addCustomWorkType(newWT);
    return newWT;
  };

  return (
    <Autocomplete
      id="workTypeSelect"
      value={id}
      options={filtered}
      inputPlaceholder={t("views.import.select_system")}
      inputValue={localValue}
      fullWidth
      idKey="id"
      labelKey="name"
      size="small"
      disableClearable
      onChange={handleChange}
      onInputChange={handleInputChange}
      onOptionCreate={handleWorkTypeCreate}
      getOptionDisabled={(option) => Boolean(importWorkTypes.find(o => o.id === option.id))}
      fieldClassName="mb-0"
      InputProps={{
        className: classnames(classes.workTypeAutocompleteTextField, "p-0 mb-0"),
      }}
      inputProps={{
        className: "py-1 pr-6"
      }}
      classes={{
        endAdornment: classes.endAdornment
      }}
    />
  );
};

WorkTypeSelector.propTypes = {
  id: oneOfType([number, string]).isRequired,
  index: number.isRequired,
  name: string.isRequired,
  isCustom: bool
};
